<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer('user')}}</div>

        <v-card class="shadow-none" v-if="!needInit">     
            <v-card-text v-if="myContent">
                <div v-for="(item,index) in myList" :key="index">
                    <p v-if="item.type=='<p>'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <!-- <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span> -->
                                    <v-icon v-if="showAns == 2 && (el.content == el.answer)"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (el.content != el.answer)"  v-bind:style="check_error">error</v-icon>  
                                </v-chip>
<!--                                 <v-chip v-if="showAns == 2 && (el.content != el.answer)" color="lime lighten-3">
                                    <span type = "text" v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
 -->                            </span>
                        </span>
                    </p>       
                    <div id = "mycode" v-if="item.type=='<pre'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <!-- <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span> -->
                                
                                    <v-icon v-if="showAns == 2 && (el.content == el.answer)"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (el.content != el.answer)"  v-bind:style="check_error">error</v-icon>  
                                </v-chip>
                            </span>
                        </span>
                    </div>                
                </div>
            </v-card-text>

        </v-card>

    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth.js'
import * as logs from '../../assets/log_process.js'

export default {   
    data() {
        return {
                myContent: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                fullContent: null,
                showAns: 0, // 0 - user content, 1 - correct content, 2 - check
                myList: [
                    {
                        type: 'p', // p, li
                        list: [
                            {
                                type: 'a', // a, c
                                content : '',
                                answer: '' // correct answer
                            }
                        ]

                    }
                ],
                ignoreSpaces : false,
                aqSome : false,
                check_ok : {
                    color: "green"                    
                },
                check_error : {
                    color: "red"
                },
                correct_answer : {
                    "text-align":"center"
                },
                startTime : null

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
        initData() {
            this.needInit = false         
            this.showAns = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)            
            const globals = JSON.parse(this.dcontent.data.globals)
            this.ignoreSpaces = globals.ignoreSpaces
            this.aqSome = globals.aqSome
  
            // typy prvkov su 3:
            // <p> pre obycajny text
            // <pre> pre kod
            // 
            
            // vo fullContent obsahujem cely obsah co prisiel co prisiel v podobe html
            this.myList = [] // zoznam do ktoreho budu nahodene postupne vsetky typy prvkov
            // unspan vyhodi vsetky spany bez ohladu na to co obsahuju - hladam zaciatocny tag, koncovy zobak a koncovy tag
            this.fullContent = this.unSpan(this.myContent.content)

            // tu sa rozhodujem ci este treba prehladava fullContent, v parseData sa z neho postupne od zaciatku zostrihuje
            // ak obsahuje <pre alebo <p (pozor mozu by za nimi parametre zato nie je zobak <pre uzavrety) tak ideme tahat obsah
            while (this.fullContent.indexOf('<p>') > -1 || this.fullContent.indexOf('<pre') > -1 ) { 
                // ak su tam obidva tagy vezmem ten, ktory je skor a idem vyextrahovat z fullContent prislusnu cast
                if ((this.fullContent.indexOf('<pre') > -1)  && (this.fullContent.indexOf('<p>') > -1)) {
                       if (this.fullContent.indexOf('<pre') > this.fullContent.indexOf('<p>')) {
                         this.parseData('<p>','</p>')       
                       } else {
                         this.parseData('<pre','</pre>')
                       }
                } else {
                    // ak je tam len jeden tak vezmem ten, ktory sa tam vyskytuje
                    if (this.fullContent.indexOf('<pre') > -1) {
                         this.parseData('<pre','</pre>')   
                    } else {
                        this.parseData('<p>','</p>')      
                    }    
                }
            }      
        },


    //************************************************************************************ */        
    //  methods for content preparing
    //************************************************************************************ */        
        setBR(line) {
            var start = 0
            while (line.indexOf('\n') > -1) {
                start = line.indexOf('\n')
                if ((start > 0 ) && (start-1, start) != '§') {
                    line = line.substring(0,start) + '<br/>' + line.substring(start+1)
                }
            }
            return line
        },
        parseData(tag,endTag) {
            var mList = []
            // najdem poziciu kde zacina tag
            var start = this.fullContent.indexOf(tag);
            var start2 = 0
            // tili >
            // start2 je pozicia kde konci zobak daneho tagu
            if (tag == '<p>') {
                start2 = start + 2
            } else {
                start2 =  this.fullContent.indexOf('>',start);
            }

            // najdem poziciu kde konci tag </p, </pre>>
            var end = this.fullContent.indexOf(endTag)
            // ak bola pozicia uvodneho tagu nie na zaciatku napr. nejaky text este pred p alebo pre 
            // tak si ten obsah zapamatam ako content typ c
            if (start > 0) {
                // vlozim ju ako obsah - type je c
                mList.push( 
                    {
                      type: 'c',
                      content: this.fullContent.substring(0,start),
                      answer: ''
                    }
                )
            }
            // precitam obsah medzi tagmi
            var line = this.fullContent.substring(start2 + 1 , end)
            // change \n to br
            // ak robim s pre, potrebujem to dat do html takze musim nahradit dve medzery za sebou a entery 
            if (tag=='<pre') {
                // nahradza entery
                line = this.setBR(line)
                // toto vsetko dalsie nahradza medzery
                // spaces at the begin of line
                var spaces = '';
                while (line.indexOf(' ') == 0) {
                    spaces = spaces + '&nbsp;'
                    line = line.substring(1)
                }
                line = spaces + line
                // to last line
                while (line.indexOf('<br/> ') > -1) {
                    start = line.indexOf('<br/> ')
                    line = line.substring(0,start) + '<br/>&nbsp;' + line.substring(start+6)
                }
                while (line.indexOf('&nbsp; ') > -1) {
                    start = line.indexOf('&nbsp; ')
                    line = line.substring(0,start) + '&nbsp;&nbsp;' + line.substring(start+7)
                }
            }
            // nahradil som vsetko co bolo treba, zostrihnem zaciatok
            this.fullContent = this.fullContent.substring(end + endTag.length)

            // idem hladat ci v mojom medzitagovom texte ci tam nie su doplnovacky
            // kym su tak:
            while (line.indexOf('§§') > -1) {
                // najdem zaciatok
                start = line.indexOf('§§')
                // vsetko po zaciatocny paragraf je content
                if (start > 0) {
                    mList.push( 
                        {
                        type: 'c',
                        content: line.substring(0,start),
                        answer: ''
                        }
                    )
                }
                end = line.indexOf('§§',start+1)
                // vsetko po koncovy paragraf je na doplnenie
                // pamatam si aj spravnu odpoverd aby sa mi lahko porovnavalo
                // makeNice robi zobaciky a znaky, ktore su v html zakodovane na normalne znaky
                mList.push( 
                    {
                        type: 'a',
                        content: '',
                        answer: this.makeNice(line.substring(start+2, end))
                    }
                )                
                // ciara zo seba zostrihne pouzitu cast
                line = line.substring(end + 2)
                
            }

            // ak este po poslednom paragrafe mame nejaky obsah tak ho dopracujeme
            // if it is finished by </tag>
            if (line.indexOf(endTag) > 0) {
                line = line.substring(0,line.indexOf(endTag))                    
            }

            // to co ostalo je content
            if (line.length > 0) {                
                mList.push( 
                    {
                    type: 'c',
                    content: line,
                    answer: ''
                    }
                )
            } 

            // pre prislusny tag mam zoznam poloziek, 
            // ktore su kodovane ako c alebo a content alebo answer a podla toho potom vyrabam obsah v casti html
            // ktora je na zaciatku suboru
            this.myList.push( {
                type: tag,
                list: mList
            })

        },
        unSpan(txt) {
            var data = txt
            var start = 0
            var end = 0
            while (data.indexOf('<span') > -1) {
                start = data.indexOf('<span')
                end = data.indexOf('>',start)
                data = data.substring(0,start) + data.substring(end+1)
                start = data.indexOf('</span>')
                data = data.substring(0,start) + data.substring(start+7)                
            }
            return data
        },
        //*********************************************************************************** */
        //***************              DATA MANIPULATION                                      */
        //*********************************************************************************** */
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)

            var answList = []
            for(let j = 0; j < this.myList.length; j++)
                for(let i = 0; i < this.myList[j].list.length; i++) {
                    if (this.myList[j].list[i].type == 'a') answList.push(this.myList[j].list[i].content)
                }

            // send info to server
            const data = {
                task_id : this.dcontent.task_id,
                task_type_id: this.dcontent.task_type_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                answer_list : JSON.stringify(answList), 
                activity_type: this.activity_type
            }
            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {          
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)

            var index = 0             
            for(let j = 0; j < this.myList.length; j++)
                for(let i = 0; i < this.myList[j].list.length; i++) {
                    if (this.myList[j].list[i].type == 'a') {
                        if (myData.result.answers[index].rating == 1) {
                            this.myList[j].list[i].answer = myData.result.answers[index].answer
                            this.myList[j].list[i].content = myData.result.answers[index].answer
                        } else
                            this.myList[j].list[i].answer = myData.result.answers[index].answer+'x' 
                        index++;
                    }
                }

            this.showAns = 2
        },          
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        }, 
        useAnswer(myData) {
            var index = 0             
            for(let j = 0; j < this.myList.length; j++)
                for(let i = 0; i < this.myList[j].list.length; i++) {
                    if (this.myList[j].list[i].type == 'a') {
                        this.myList[j].list[i].answer = this.makeNice(myData.answers[index])
                        this.myList[j].list[i].content = this.makeNice(myData.answers[index])
                        index++;
                    }
                }

            this.$store.commit('setUserPerformance',myData.user)
        },  
        getStyle(index, index2) {
            if (this.showAns == 0) return { "color":"black",
                                            "text-align":"center"}            
            if (this.showAns == 1) return { 
                                            "text-align":"center"}

            if (this.showAns == 2 && (this.myList[index].list[index2].content != this.myList[index].list[index2].answer)) 
                                            return { "color":"red",
                                                    "text-align":"center"}
            if (this.showAns == 2 && (this.myList[index].list[index2].content == this.myList[index].list[index2].answer)) 
                                            return { "color":"green",
                                                    "text-align":"center"}
        },        
        makeNice(a) {
            while (a.indexOf('&lt;')>-1) a = a.replace('&lt;','<')
            while (a.indexOf('&gt;')>-1) a = a.replace('&gt;','>')
            while (a.indexOf('&amp;')>-1) a = a.replace('&amp;','&')
            return a
        },       
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>
#mycode {
	width: 100%;
	padding: 5px;
	margin: 10px;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 18px;
    font-weight: bold;
	background:  gainsboro; 
	border: 1px solid #777;
    font-family:'Courier New', Courier, monospace; 
}
.ql-snow .ql-editor pre.ql-syntax{background-color:gainsboro; color:#000;overflow:visible}
</style>